import { Box, Grid, useTheme } from '@mui/material';
import { useState } from 'react';

import AppHeader from 'src/components/app-header/app-header';
import Scrollbar from 'src/components/scrollbar';
import Sidebar from 'src/components/sidebar/sidebar';
import { useResponsive } from 'src/hooks/use-responsive';
import { useUserStore } from 'src/stores/user/user.store';

// import Header from '../header/header';

type Props = {
  children: React.ReactNode;
};

export default function DefaultLayout({ children }: Props) {
  const { user } = useUserStore((state) => state);
  const [openDrawer, setOpenDrawer] = useState(false);
  const theme = useTheme();
  const mediaQuery = useResponsive;

  const handleOpenDrawer = () => {
    setOpenDrawer((prevState) => !prevState);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: 1 }}>
      <Box
        bgcolor={theme.palette.background.paper}
        component="main"
        sx={{
          flexGrow: 1,
        }}
      >
        <Grid container direction="row" wrap="nowrap" width="100vw" height="100vh" overflow="hidden">
          {mediaQuery('up', 'lg') ? (
            <Grid item xs={2.5} height="100vh" boxShadow="1px 0px 15px #0000003d">
              <Sidebar />
            </Grid>
          ) : (
            <Sidebar onClose={handleOpenDrawer} drawer open={openDrawer} />
          )}
          <Grid item container direction="column" wrap="nowrap" flex={1} width={mediaQuery('up', 'lg') ? '85%' : '100%'}>
            <Grid borderBottom={`1px solid ${theme.palette.greyScale[100]}`} item xs={1.5} zIndex={1}>
              <AppHeader handleOpenDrawer={handleOpenDrawer} title={user?.name} subtitle={user?.role.name} />
            </Grid>
            <Grid item flex={1} overflow="auto" maxHeight="calc(100vh - 120px)">
              <Scrollbar>
                <Box p={mediaQuery('down', 'sm') ? 4 : 6}>{children}</Box>
              </Scrollbar>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
